import { useState } from 'react';

import { motion } from 'framer-motion';

const WipeOverlay: React.FC = () => {
  const [done, setDone] = useState(false);
  if (done) return null;
  return (
    <>
      <motion.div
        initial={{ x: '-120%', skewX: -10 }}
        animate={{ x: '120%' }}
        transition={{ duration: 0.7, ease: [0.33, 1, 0.68, 1] }}
        className="from-primary-400/60 to-primary-300/50 dark:from-primary-700/50 dark:to-primary-600/40 pointer-events-none fixed inset-y-0 -left-[10%] z-[99998] w-[120%] bg-gradient-to-r backdrop-blur-[4px]"
      />
      <motion.div
        initial={{ x: '-120%', skewX: -10 }}
        animate={{ x: '120%' }}
        onAnimationComplete={() => setDone(true)}
        transition={{ duration: 0.75, delay: 0.06, ease: [0.33, 1, 0.68, 1] }}
        className="from-secondary-400/60 to-secondary-300/50 dark:from-secondary-700/50 dark:to-secondary-600/40 pointer-events-none fixed inset-y-0 -left-[10%] z-[99999] w-[120%] bg-gradient-to-r backdrop-blur-[4px]"
      />
    </>
  );
};

export default WipeOverlay;
